import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Persistent admin session: keep a copy of the session_token in localStorage so
// if the HttpOnly cookie is dropped (e.g. 3rd-party cookie blocking, Safari
// cross-site, or browser restart on some mobile OSes), the Bearer header still
// authenticates the admin for ~1 year.
api.interceptors.request.use((config) => {
  try {
    const tok = localStorage.getItem("ikz_session_token");
    if (tok && !config.headers?.Authorization) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${tok}`;
    }
  } catch {}
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    // On 401 drop the cached token so we don't keep sending a dead one.
    if (e?.response?.status === 401) {
      try { localStorage.removeItem("ikz_session_token"); } catch {}
    }
    return Promise.reject(e);
  }
);
